/* EFF-001 V1. Shared pure functions: no network, storage or random enrollment. */
(function(root,factory){
  var api=factory();
  if(typeof module==='object'&&module.exports) module.exports=api;
  else root.EFKContract=api;
})(typeof globalThis!=='undefined'?globalThis:this,function(){
  'use strict';
  var VERSION='efk-cro-v1.0';
  var SKU='FKT-T-EG-4';
  var VARIANT='67446052192301';
  var SESSION_MS=30*60*1000;
  var promises=['carrot_pickle','sauerkraut_meal','kimchi','seasonal_entertaining','four_ferment_system','organic_default'];
  var legacyContent={
    'carrot-discovery-ad01':'carrot_pickle','carrot-discovery-ad02':'carrot_pickle',
    'grilled-cheese-ad03':'sauerkraut_meal','grilled-cheese-ad04':'sauerkraut_meal',
    'kimchi-batch-care-ad05':'kimchi','kimchi-batch-care-ad06':'kimchi',
    'future-dish-ad01':'seasonal_entertaining','hosting-pride-ad02':'seasonal_entertaining',
    'workaround-ad07':'four_ferment_system'
  };
  var legacyIds={
    '120250529915310517':'carrot_pickle','120250529915670517':'carrot_pickle',
    '120250529916420517':'sauerkraut_meal','120250529917530517':'sauerkraut_meal',
    '120250529918410517':'kimchi','120250529919200517':'kimchi',
    '120250530462750517':'seasonal_entertaining','120250530465260517':'seasonal_entertaining',
    '120250374138160517':'four_ferment_system'
  };
  var keys={
    exposure_id:'_efk_exposure_id',entry_session_id:'_efk_entry_session_id',
    visitor_id:'_efk_visitor_id',promise_id:'_efk_promise_id',
    experiment_id:'_efk_experiment_id',variant_id:'_efk_variant_id',
    exposure_at:'_efk_exposure_at',is_test:'_efk_test'
  };
  function own(o,k){return Object.prototype.hasOwnProperty.call(o,k);}
  function validId(s){return typeof s==='string'&&/^[a-zA-Z0-9_-]{1,100}$/.test(s);}
  function validExposure(s){return typeof s==='string'&&/^efk_[a-zA-Z0-9_-]{16,90}$/.test(s);}
  function resolve(search){
    var q=new URLSearchParams(search||''),explicit=q.get('promise_id');
    // An unknown explicit promise must not fall back to a misleading campaign keyword.
    if(explicit!==null)return {promise_id:promises.indexOf(explicit)>=0?explicit:'organic_default',route_source:promises.indexOf(explicit)>=0?'explicit':'unknown_explicit'};
    if(own(legacyIds,q.get('ad_id')))return {promise_id:legacyIds[q.get('ad_id')],route_source:'legacy_ad_id'};
    if(own(legacyContent,q.get('utm_content')))return {promise_id:legacyContent[q.get('utm_content')],route_source:'legacy_utm_content'};
    return {promise_id:'organic_default',route_source:'default'};
  }
  function assignment(visitorId,experimentId){
    if(!validId(visitorId)||!validId(experimentId))throw new Error('Invalid assignment identity');
    var s=experimentId+':'+visitorId,h=2166136261;
    for(var i=0;i<s.length;i++){h^=s.charCodeAt(i);h=Math.imul(h,16777619);}
    return (h>>>0)%2?'challenger':'control';
  }
  function properties(e){
    if(!validExposure(e.exposure_id))throw new Error('Invalid exposure ID');
    var p={};
    Object.keys(keys).forEach(function(k){p[keys[k]]=String(e[k]===undefined?'':e[k]);});
    p._efk_contract=VERSION;
    return p;
  }
  function propertyMap(value){
    if(Array.isArray(value)){
      var result={};
      value.forEach(function(p){var k=p.key||p.name;if(k)result[k]=String(p.value);});
      return result;
    }
    return value||{};
  }
  function contextFromLine(line){
    var p=propertyMap(line.properties||line.customAttributes);
    if(p._efk_contract!==VERSION||!validExposure(p._efk_exposure_id))return null;
    var e={contract_version:VERSION};
    Object.keys(keys).forEach(function(k){e[k]=p[keys[k]];});
    if(!validId(e.entry_session_id)||!validId(e.visitor_id)||!validId(e.experiment_id)||
       !validId(e.variant_id)||promises.indexOf(e.promise_id)<0||!Number.isFinite(Date.parse(e.exposure_at)))return null;
    if(e.is_test!=='true'&&e.is_test!=='false')return null;
    e.is_test=e.is_test==='true';
    return e;
  }
  function eligible(e){
    return !!(e&&e.landing_path==='/pages/fermentation-kit'&&e.eligible===true&&
      !e.is_test&&!e.is_internal&&!e.is_bot&&e.analytics_allowed===true&&
      e.capture_ready===true&&validExposure(e.exposure_id)&&validId(e.entry_session_id)&&
      validId(e.visitor_id)&&validId(e.experiment_id)&&validId(e.variant_id)&&
      promises.indexOf(e.promise_id)>=0&&Number.isFinite(Date.parse(e.exposure_at)));
  }
  function liveGate(g){
    var required=['baseline_captured','exposure_ingestion','shopify_order_join','checkout_entry_observed',
      'dedupe_verified','coverage_reviewed','mobile_checkout_verified','page_reviewed',
      'economics_and_spend_approved','experiment_launch_approved'];
    return !!(g&&required.every(function(k){return g[k]===true;})&&
      typeof g.evidence_manifest_sha256==='string'&&/^[0-9a-f]{64}$/.test(g.evidence_manifest_sha256));
  }
  function summarize(events,orders,options){
    options=options||{};
    var exposures=new Map(),sessionSeen=new Map(),cta=new Set(),checkout=new Set();
    var coverage={exposure_events:0,eligible_sessions:0,duplicate_exposures:0,excluded_exposures:0,
      eligible_sku_orders:0,matched_orders:0,unmatched_orders:0,test_or_invalid_orders:0,
      ambiguous_orders:0,late_or_nonprimary_orders:0,duplicate_order_records:0,missing_revenue_orders:0};
    events.forEach(function(ev){
      if(ev.event!=='fermentation_lp_viewed')return;
      var e=ev.properties||ev;coverage.exposure_events++;
      if(!eligible(e)){coverage.excluded_exposures++;return;}
      if(exposures.has(e.exposure_id)||sessionSeen.has(e.entry_session_id)){coverage.duplicate_exposures++;return;}
      exposures.set(e.exposure_id,Object.assign({},e));sessionSeen.set(e.entry_session_id,e.exposure_id);
    });
    coverage.eligible_sessions=exposures.size;
    events.forEach(function(ev){
      var p=ev.properties||ev;
      if(!exposures.has(p.exposure_id))return;
      if(ev.event==='fermentation_primary_cta_clicked')cta.add(p.exposure_id);
      if(ev.event==='fermentation_checkout_started'&&p.source==='shopify_customer_events')checkout.add(p.exposure_id);
    });
    var activity=new Map();
    events.forEach(function(ev){
      var p=ev.properties||ev;
      if(!exposures.has(p.exposure_id)||['fermentation_primary_cta_clicked','fermentation_checkout_started','fermentation_session_activity'].indexOf(ev.event)<0)return;
      var stamp=Date.parse(p.activity_at||p.event_at||p.last_activity_at||ev.timestamp);
      if(!Number.isFinite(stamp))return;
      if(!activity.has(p.exposure_id))activity.set(p.exposure_id,[]);
      activity.get(p.exposure_id).push(stamp);
    });
    var groups={};
    function group(e){
      var key=e.experiment_id+'|'+e.variant_id;
      if(!groups[key])groups[key]={experiment_id:e.experiment_id,variant_id:e.variant_id,eligible_sessions:0,
        cta_sessions:0,checkout_sessions:0,purchasing_sessions:0,orders:0,net_sku_revenue:0,contribution:null};
      return groups[key];
    }
    exposures.forEach(function(e,id){var g=group(e);g.eligible_sessions++;if(cta.has(id))g.cta_sessions++;if(checkout.has(id))g.checkout_sessions++;});
    // Input contract: latest authoritative snapshot per Shopify order, with normalized SKU net revenue.
    var latestOrders=new Map();
    orders.forEach(function(o){
      if(!o.order_id)return;
      if(latestOrders.has(String(o.order_id)))coverage.duplicate_order_records++;
      var previous=latestOrders.get(String(o.order_id));
      if(!previous||Date.parse(o.updated_at||o.created_at)>=Date.parse(previous.updated_at||previous.created_at))latestOrders.set(String(o.order_id),o);
    });
    var buyers=new Set(),matched=[],assisted=[],unmatched=[];
    latestOrders.forEach(function(o){
      var lines=(o.line_items||[]).filter(function(l){return l.sku===SKU;});
      if(!lines.length)return;
      if(o.is_test||o.is_internal||o.cancelled_at||['paid','partially_refunded','refunded'].indexOf(o.financial_status)<0){
        coverage.test_or_invalid_orders++;return;
      }
      coverage.eligible_sku_orders++;
      var contexts=lines.map(contextFromLine);
      if(contexts.some(function(c){return !c||c.is_test;})){coverage.unmatched_orders++;unmatched.push({order_id:o.order_id,reason:'missing_or_test_line_identity'});return;}
      var ids=Array.from(new Set(contexts.map(function(c){return c.exposure_id;})));
      if(ids.length!==1){coverage.ambiguous_orders++;unmatched.push({order_id:o.order_id,reason:'multiple_exposure_ids'});return;}
      var id=ids[0],e=exposures.get(id),c=contexts[0];
      if(!e||['entry_session_id','visitor_id','promise_id','experiment_id','variant_id'].some(function(k){return c[k]!==String(e[k]);})){
        coverage.unmatched_orders++;unmatched.push({order_id:o.order_id,reason:'missing_exposure_or_identity_mismatch'});return;
      }
      var purchaseAt=Date.parse(o.created_at),exposureAt=Date.parse(e.exposure_at);
      if(!Number.isFinite(purchaseAt)||purchaseAt<exposureAt){coverage.unmatched_orders++;unmatched.push({order_id:o.order_id,reason:'invalid_purchase_time'});return;}
      // Primary is entry-session conversion. A reliable last observed activity is required.
      var lastActive=exposureAt;
      (activity.get(id)||[]).filter(function(t){return t>=exposureAt&&t<=purchaseAt;}).sort(function(a,b){return a-b;}).some(function(t){
        if(t-lastActive>=SESSION_MS)return true;
        lastActive=t;return false;
      });
      var endAt=lastActive+SESSION_MS;
      if(purchaseAt>=endAt){coverage.late_or_nonprimary_orders++;assisted.push({order_id:o.order_id,exposure_id:id,reason:'outside_entry_session_window'});return;}
      coverage.matched_orders++;
      var g=group(e);g.orders++;buyers.add(id);
      var net=lines.map(function(l){return l.net_revenue;});
      if(o.currency!=='USD'||net.some(function(v){return typeof v!=='number'||!Number.isFinite(v);})){
        coverage.missing_revenue_orders++;g.net_sku_revenue=null;
      }else if(g.net_sku_revenue!==null){g.net_sku_revenue+=net.reduce(function(a,b){return a+b;},0);}
      matched.push({order_id:o.order_id,exposure_id:id,entry_session_id:e.entry_session_id,experiment_id:e.experiment_id,variant_id:e.variant_id});
    });
    buyers.forEach(function(id){group(exposures.get(id)).purchasing_sessions++;});
    Object.keys(groups).forEach(function(k){
      var g=groups[k];g.purchase_rate=g.eligible_sessions?g.purchasing_sessions/g.eligible_sessions:null;
      g.net_revenue_per_session=g.net_sku_revenue===null?null:g.net_sku_revenue/g.eligible_sessions;
      var checkoutBuyers=matched.filter(function(m){return m.variant_id===g.variant_id&&m.experiment_id===g.experiment_id&&checkout.has(m.exposure_id);});
      g.checkout_completion=g.checkout_sessions?new Set(checkoutBuyers.map(function(m){return m.exposure_id;})).size/g.checkout_sessions:null;
      if(typeof options.contribution_per_order==='number'&&Number.isFinite(options.contribution_per_order)){
        g.contribution=g.orders*options.contribution_per_order;
        g.contribution_per_session=g.contribution/g.eligible_sessions;
      }else g.contribution_per_session=null;
    });
    return {contract_version:VERSION,scope:'Observed eligible entry-session cohort; not all site visitors or Meta attribution',
      primary_metric:'distinct eligible entry sessions with a Shopify-confirmed SKU purchase / eligible entry sessions',
      coverage:coverage,groups:Object.values(groups),matched:matched,assisted:assisted,unmatched:unmatched,
      live_gate_passed:false,causal_claim_allowed:false};
  }
  return {VERSION:VERSION,SKU:SKU,VARIANT:VARIANT,SESSION_MS:SESSION_MS,promises:promises,
    keys:keys,resolve:resolve,assignment:assignment,properties:properties,contextFromLine:contextFromLine,
    eligible:eligible,liveGate:liveGate,summarize:summarize};
});

;
/* Enrichment only. No network, storage, page mutation or experiment assignment. */
(function(root,factory){
  var api=factory();
  if(typeof module==='object'&&module.exports)module.exports=api;else root.ElementiAgentContext=api;
})(typeof globalThis!=='undefined'?globalThis:this,function(){
  'use strict';
  function device(nav){
    var ua=String(nav&&nav.userAgent||'');
    if(/iPad|Tablet|PlayBook/i.test(ua)||(/Macintosh/i.test(ua)&&nav.maxTouchPoints>1)||(/Android/i.test(ua)&&!/Mobile/i.test(ua)))return 'tablet';
    if(/iPhone|iPod|Android.*Mobile|Windows Phone/i.test(ua)||nav&&nav.userAgentData&&nav.userAgentData.mobile===true)return 'mobile';
    if(/Windows NT|Macintosh|X11|CrOS/i.test(ua))return 'desktop';
    return 'unknown';
  }
  function platform(search,referrer,route){
    var q=new URLSearchParams(search||''),source=(q.get('utm_source')||'').trim().toLowerCase();
    if(['facebook','fb','instagram','ig','meta'].indexOf(source)>=0)return {value:'meta',basis:'utm_source'};
    if(source)return {value:'other',basis:'explicit_other_source'};
    if(route&&['legacy_ad_id','legacy_utm_content'].indexOf(route.route_source)>=0)return {value:'meta',basis:'verified_legacy_ad_mapping'};
    var host='';try{host=new URL(referrer).hostname.toLowerCase();}catch(e){}
    if(/(^|\.)(facebook|instagram)\.com$/.test(host)||host==='fb.com')return {value:'meta',basis:'referrer_host'};
    return {value:'unknown',basis:'insufficient_source_evidence'};
  }
  function context(input){
    var p=platform(input.search,input.referrer,input.route),visitor=input.visitor||{},sid=null;
    try{if(input.posthog&&typeof input.posthog.get_session_id==='function')sid=input.posthog.get_session_id();}catch(e){}
    return {agent_contract_version:'elementi-agent-cro-v1',device_type:device(input.navigator),
      device_basis:'ua_derived_not_viewport',acquisition_platform:p.value,acquisition_basis:p.basis,
      first_observed_at:visitor.first_seen_at||null,
      first_observed_session:visitor.first_entry_session_id?visitor.first_entry_session_id===input.sessionId:null,
      posthog_session_id:typeof sid==='string'?sid:null,
      analytics_promise_id:input.route&&input.route.route_source==='unknown_explicit'?'unknown':input.route&&input.route.promise_id||'unknown'};
  }
  return {context:context,device:device,platform:platform};
});

;
/* Install on every storefront page after consent + the existing PostHog SDK.
 * No SDK credentials, no checkout mutation and no experiment enrollment by default.
 */
(function(w){
  'use strict';
  var C=w.EFKContract,Agent=w.ElementiAgentContext;
  if(!C)throw new Error('Load EFKContract before EFKStorefront');
  if(!Agent)throw new Error('Load ElementiAgentContext before EFKStorefront');
  var KEY='efk_cro_v1_session',VISITOR='efk_cro_v1_visitor';
  var active=null,config=null,installed=false,lastSent=0,sitePageSent=false,siteContext=null;
  function uid(){
    if(typeof w.crypto.randomUUID==='function')return 'efk_'+w.crypto.randomUUID().replace(/-/g,'');
    return 'efk_'+Array.from(w.crypto.getRandomValues(new Uint8Array(16)),function(n){return n.toString(16).padStart(2,'0');}).join('');
  }
  function consent(){
    try{return w.Shopify.customerPrivacy.analyticsProcessingAllowed()===true;}catch(e){return false;}
  }
  function ready(){
    try{return !!(w.posthog&&typeof w.posthog.capture==='function'&&
      config&&typeof config.sdkReady==='function'&&config.sdkReady()===true&&
      (!w.posthog.has_opted_out_capturing||!w.posthog.has_opted_out_capturing()));}
    catch(e){return false;}
  }
  function read(k){try{return JSON.parse(w.localStorage.getItem(k));}catch(e){return null;}}
  function write(k,v){try{w.localStorage.setItem(k,JSON.stringify(v));return true;}catch(e){return false;}}
  function emit(name,p,meta){
    if(!consent()||!ready())return false;
    meta=meta||{};
    var props=Object.assign({contract_version:meta.contract_version||C.VERSION,
      capture_source:meta.capture_source||'efk_v1'},p);
    try{w.posthog.capture(name,props);return true;}catch(e){return false;}
  }
  function isInternal(){
    return config.internal===true||/[?&]cro_internal=1(?:&|$)/.test(w.location.search)||
      /bot|crawler|spider|headless/i.test(w.navigator.userAgent)||w.navigator.webdriver===true;
  }
  function strip(){
    w.document.querySelectorAll('input[data-efk-join]').forEach(function(i){i.remove();});
    w.document.querySelectorAll('input[data-elementi-site-join]').forEach(function(i){i.remove();});
    active=null;
  }
  function formContext(){
    if(!active||!consent()||!ready()||isInternal())return null;
    return Object.assign({},active.exposure,{last_activity_at:new Date().toISOString()});
  }
  function decorate(form){
    form.querySelectorAll('input[data-efk-join]').forEach(function(i){i.remove();});
    var e=formContext();
    if(!e||!form.querySelector('input[name="id"][value="'+C.VARIANT+'"]'))return;
    var p=C.properties(e);
    Object.keys(p).forEach(function(k){
      var input=w.document.createElement('input');
      input.type='hidden';input.name='properties['+k+']';input.value=p[k];
      input.dataset.efkJoin='true';form.appendChild(input);
    });
  }
  function cartForm(form){
    if(!form||!form.matches||!form.matches('form')||!form.querySelector('input[name="id"]'))return false;
    try{return new URL(form.getAttribute('action')||'',w.location.origin).pathname==='/cart/add';}
    catch(e){return false;}
  }
  function siteJoinProperties(context){
    return {_elementi_contract:'elementi-site-v1',
      _elementi_entry_session_id:String(context.entry_session_id),
      _elementi_visitor_id:String(context.visitor_id),
      _elementi_landing_path:String(context.landing_path),
      _elementi_page_path:String(context.page_path),
      _elementi_captured_at:new Date().toISOString(),_elementi_test:'false'};
  }
  function decorateSite(form){
    form.querySelectorAll('input[data-elementi-site-join]').forEach(function(i){i.remove();});
    if(!cartForm(form)||!siteContext||!consent()||!ready()||isInternal())return;
    var props=siteJoinProperties(siteContext);
    Object.keys(props).forEach(function(k){
      var input=w.document.createElement('input');
      input.type='hidden';input.name='properties['+k+']';input.value=props[k];
      input.dataset.elementiSiteJoin='true';form.appendChild(input);
    });
  }
  function sitePage(path,session,visitor){
    // This is intentionally separate from the fermentation conversion contract.
    // It has no query string, referrer URL, form value, cart, customer, or
    // checkout data. Product purchase attribution remains product-specific.
    if(sitePageSent)return true;
    var route={promise_id:'unknown',route_source:'sitewide'},context=Agent.context({
      navigator:w.navigator,posthog:w.posthog,search:w.location.search,
      referrer:w.document.referrer,visitor:visitor,sessionId:session.id,route:route});
    var props=Object.assign({site_contract_version:'elementi-site-v1',
      page_path:path,landing_path:session.landing_path,entry_session_id:session.id,
      visitor_id:visitor.id,analytics_allowed:true,is_test:false,is_internal:false,
      is_bot:false},context);
    try{props.referrer_host=new URL(w.document.referrer).hostname;}catch(e){props.referrer_host='';}
    siteContext=props;
    sitePageSent=emit('elementi_storefront_page_viewed',props,
      {contract_version:'elementi-site-v1',capture_source:'elementi_site_v1'});
    return sitePageSent;
  }
  function begin(){
    if(!config||config.mode==='preview'||!consent()||!ready()||isInternal()){strip();return false;}
    if(!w.crypto||typeof w.crypto.getRandomValues!=='function'){strip();return false;}
    var now=Date.now(),path=w.location.pathname.replace(/\/$/,'')||'/';
    var session=read(KEY),visitor=read(VISITOR),newVisitor=false;
    if(!visitor||typeof visitor.id!=='string'||!/^efk_[a-z0-9]{32}$/.test(visitor.id)){
      newVisitor=true;visitor={id:uid(),first_seen_at:new Date(now).toISOString()};
      if(!write(VISITOR,visitor))return false;
    }
    var fresh=!session||!Number.isFinite(session.last_activity)||now-session.last_activity>=C.SESSION_MS||
      session.last_activity>now+60000||typeof session.id!=='string';
    if(fresh){
      // A same-site entry with no session record is unknown, not silently LP-eligible.
      var ref;try{ref=new URL(w.document.referrer);}catch(e){}
      var unknownSameSite=!!(ref&&ref.hostname===w.location.hostname);
      session={id:uid(),started:now,last_activity:now,landing_path:unknownSameSite?'unknown_same_site':path};
    }
    session.last_activity=now;
    if(!write(KEY,session))return false;
    if(newVisitor){visitor.first_entry_session_id=session.id;if(!write(VISITOR,visitor))return false;}
    // A pseudonymous stable ID, never an email/customer ID. Explicit callback is
    // required so the storefront and checkout SDKs share the same person identity.
    try{if(typeof config.identifyVisitor!=='function'||config.identifyVisitor(visitor.id)!==true){strip();return false;}}
    catch(e){strip();return false;}
    var experiment=config.mode==='experiment'&&C.liveGate(config.gate);
    if(config.mode==='experiment'&&!experiment){strip();return false;}
    // Capture one PII-minimized page event for each normal storefront document.
    // A failure here must not suppress the established fermentation contract.
    sitePage(path,session,visitor);
    if(session.landing_path!=='/pages/fermentation-kit'){active=null;return false;}
    var onLandingPage=path==='/pages/fermentation-kit';
    var route=C.resolve(w.location.search),root=w.document.querySelector('#efk-main');
    var variant=experiment?C.assignment(visitor.id,config.experiment_id):'baseline';
    // This adapter records the experience; it never changes or randomizes the DOM.
    if(experiment&&onLandingPage&&(!root||root.dataset.croVariant!==variant)){strip();return false;}
    if(session.exposure&&(session.exposure.variant_id!==variant||
      session.exposure.experiment_id!==(experiment?config.experiment_id:'none'))){strip();return false;}
    if(!onLandingPage){
      if(!session.exposure){strip();return false;}
      active=session;touch();return true;
    }
    if(!session.exposure){
      session.exposure={exposure_id:uid(),entry_session_id:session.id,visitor_id:visitor.id,
        promise_id:route.promise_id,experiment_id:experiment?config.experiment_id:'none',
        variant_id:variant,exposure_at:new Date(now).toISOString(),last_activity_at:new Date(now).toISOString(),
        landing_path:session.landing_path,eligible:true,is_test:false,is_internal:false,is_bot:false,
        analytics_allowed:true,capture_ready:true,route_source:route.route_source,
        rendered_hero_id:root?root.dataset.entryAngle:'unknown'};
      ['utm_source','utm_medium','utm_campaign','utm_content'].forEach(function(k){
        var value=new URLSearchParams(w.location.search).get(k);session.exposure[k]=value?value.slice(0,200):null;
      });
      Object.assign(session.exposure,Agent.context({navigator:w.navigator,posthog:w.posthog,
        search:w.location.search,referrer:w.document.referrer,visitor:visitor,
        sessionId:session.id,route:route}));
      // Browser context comes from PostHog; no raw referrer query strings are retained.
      session.exposure.referrer_host=(function(){try{return new URL(w.document.referrer).hostname;}catch(e){return '';}})();
      if(!emit('fermentation_lp_viewed',session.exposure)){session.exposure=null;write(KEY,session);return false;}
    }
    active=session;write(KEY,session);
    w.document.querySelectorAll('.efk__product-form').forEach(decorate);
    w.document.querySelectorAll('form').forEach(decorateSite);
    return true;
  }
  function touch(){
    if(!active||!consent()||!ready()){if(active)strip();return;}
    var now=Date.now();
    if(now-active.last_activity>=C.SESSION_MS){active=null;begin();return;}
    active.last_activity=now;active.exposure.last_activity_at=new Date(now).toISOString();write(KEY,active);
    if(now-lastSent>=60000){
      emit('fermentation_session_activity',Object.assign({},active.exposure,{activity_at:new Date(now).toISOString()}));lastSent=now;
    }
  }
  function install(cfg){
    if(installed)throw new Error('EFKStorefront already installed');
    installed=true;config=Object.assign({mode:'baseline',internal:false},cfg||{});
    if(!['baseline','experiment','preview'].includes(config.mode))throw new Error('Unknown CRO mode');
    w.document.addEventListener('visitorConsentCollected',function(){if(!consent()){strip();try{w.localStorage.removeItem(KEY);w.localStorage.removeItem(VISITOR);}catch(e){}}else begin();});
    w.document.addEventListener('submit',function(ev){
      var form=ev.target;
      if(cartForm(form)){
        decorateSite(form);
        if(siteContext){
          var variant=form.querySelector('input[name="id"]'),value=variant&&String(variant.value||'');
          emit('elementi_storefront_add_to_cart_submitted',Object.assign({},siteContext,{product_variant_id:/^[A-Za-z0-9_-]{1,100}$/.test(value)?value:'unknown'}),
            {contract_version:'elementi-site-v1',capture_source:'elementi_site_v1'});
        }
      }
      if(!form.matches('.efk__product-form'))return;
      touch();decorate(form);
      var e=formContext();
      if(e)emit('fermentation_primary_cta_clicked',Object.assign({},e,{
        cta_location:form.dataset.ctaPlacement||'unknown',
        active_promise_id:C.resolve(w.location.search).promise_id}));
      // Deliberately do not prevent submission or invent a cart/checkout success event.
    },true);
    ['pointerdown','keydown','scroll'].forEach(function(n){w.addEventListener(n,touch,{passive:true});});
    w.addEventListener('pagehide',function(){if(active){touch();if(active)emit('fermentation_session_activity',Object.assign({},active.exposure,{activity_at:new Date().toISOString()}));}});
    if(w.document.readyState==='loading')w.document.addEventListener('DOMContentLoaded',begin,{once:true});else begin();
    return {start:begin,status:function(){return {eligible:!!active,mode:config.mode,consent:consent(),sdk_ready:ready()};}};
  }
  w.EFKStorefront={install:install,start:begin};
})(window);

;
/* PostHog baseline installer. The deployment layer supplies the public capture
 * token in memory; never place the private query key in this browser config. */
(function(w){
  'use strict';
  var installed=false;
  var HOST='https://us.i.posthog.com',ASSET='https://us-assets.i.posthog.com/static/array.js';
  function allowed(){try{return w.Shopify.customerPrivacy.analyticsProcessingAllowed()===true;}catch(e){return false;}}
  function sensitive(){return /^\/(?:account|accounts|checkout|checkouts|orders|apps)(?:\/|$)/.test(w.location.pathname);}
  function cleanUrl(value){try{var u=new URL(value,w.location.origin);return u.origin+u.pathname;}catch(e){return undefined;}}
  function sanitize(event,qa){
    if(!event||!allowed()||sensitive())return null;
    var name=event.event;
    if(!/^(?:fermentation_[a-z_]+|elementi_storefront_(?:page_viewed|add_to_cart_submitted|exposure)|elementi_(?:content_[a-z_]+|product_[a-z_]+|cart_[a-z_]+|scroll_[a-z_]+|navigation_[a-z_]+|accordion_[a-z_]+|page_[a-z_]+|unresolved_[a-z_]+)|elementi_tracking_qa|\$pageview|\$pageleave|\$identify|\$snapshot)$/.test(name))return null;
    var p=Object.assign({},event.properties||{});
    ['$set','$set_once','$initial_referrer','$initial_current_url','$initial_referring_domain','$search_engine','$search_keyword','$search_query','$ip'].forEach(function(k){delete p[k];});
    ['$current_url','$referrer'].forEach(function(k){if(p[k])p[k]=cleanUrl(p[k]);});
    // The SDK's own public project-token property is mandatory for ingestion.
    // Preserve it; remove customer/checkout identifiers, not transport configuration.
    ['email','phone','name','address','customer','customer_id','checkout_token','api_key'].forEach(function(k){delete p[k];});
    Object.keys(p).forEach(function(k){if(k.indexOf('utm_')===0&&(typeof p[k]!=='string'||p[k].length>200||/@|%40/i.test(p[k])))delete p[k];});
    if(qa){p.is_test=true;p.eligible=false;p.capture_source='efk_preview_qa';}
    return Object.assign({},event,{properties:p});
  }
  function sdkStub(options,token,onError){
    // Official snippet queue contract, loaded only after Shopify permits analytics.
    if(w.posthog)return false;
    var ph=[];ph._i=[];ph.__SV=1;
    ['capture','identify','get_session_id','get_distinct_id','register','reset','set_config','opt_in_capturing','opt_out_capturing','has_opted_out_capturing','startSessionRecording','stopSessionRecording'].forEach(function(name){ph[name]=function(){ph.push([name].concat(Array.prototype.slice.call(arguments)));};});
    ph.people=[];ph.toString=function(){return 'posthog (stub)';};
    ph._i.push([token,options,'posthog']);w.posthog=ph;
    var script=w.document.createElement('script');script.async=true;script.crossOrigin='anonymous';script.src=ASSET;
    script.dataset.elementiPosthog='true';script.onerror=onError;
    (w.document.head||w.document.documentElement).appendChild(script);return true;
  }
  function install(cfg){
    if(installed)return {status:function(){return {phase:'duplicate_install_blocked'};}};
    cfg=cfg||{};
    if(typeof cfg.captureToken!=='string'||!/^phc_[A-Za-z0-9_-]{10,}$/.test(cfg.captureToken))return {status:function(){return {phase:'capture_configuration_missing'};}};
    if(!w.EFKStorefront)return {status:function(){return {phase:'adapter_missing'};}};
    installed=true;
    var qa=cfg.previewQA===true,ready=false,loading=false,phase='waiting_for_consent',sdk=null,pageviewSent=false;
    var adapter=w.EFKStorefront.install({mode:qa?'preview':'baseline',internal:false,
      sdkReady:function(){return ready&&allowed()&&!sensitive();},
      identifyVisitor:function(id){if(!sdk||!ready||!allowed())return false;sdk.identify(id);return sdk.get_distinct_id()===id;}});
    function stop(){
      ready=false;phase='consent_denied';pageviewSent=false;
      if(sdk){sdk.stopSessionRecording();sdk.opt_out_capturing({clear_persistence:true});}
    }
    function activate(){
      if(!allowed()||sensitive()){stop();return;}
      if(!sdk)return;
      sdk.opt_in_capturing({captureEventName:false});if(!qa&&typeof sdk.startSessionRecording==='function')sdk.startSessionRecording();ready=true;phase=qa?'preview_qa':'baseline_ready';
      adapter.start();
      if(!pageviewSent){
        sdk.capture('$pageview',{$current_url:cleanUrl(w.location.href),$referrer:cleanUrl(w.document.referrer)});pageviewSent=true;
        if(qa&&typeof cfg.qaRunId==='string'&&/^[a-zA-Z0-9_-]{8,80}$/.test(cfg.qaRunId))sdk.capture('elementi_tracking_qa',{qa_run_id:cfg.qaRunId,is_test:true,eligible:false});
      }
    }
    function sync(){
      if(!allowed()||sensitive()){stop();return;}
      if(sdk){activate();return;}
      if(loading)return;
      if(w.posthog){phase='existing_posthog_conflict';return;}
      loading=true;phase='loading_sdk';
      var opts={api_host:HOST,ui_host:'https://us.posthog.com',defaults:'2026-05-30',
        debug:false,autocapture:false,capture_pageview:false,capture_pageleave:false,
        capture_dead_clicks:false,capture_exceptions:false,capture_heatmaps:false,capture_performance:false,
        advanced_disable_feature_flags:true,disable_surveys:true,enable_recording_console_log:false,
        opt_out_capturing_by_default:true,opt_out_persistence_by_default:true,
        persistence:'localStorage+cookie',person_profiles:'identified_only',cross_subdomain_cookie:false,
        disable_session_recording:qa,session_recording:{maskAllInputs:true,maskTextSelector:'*',
          blockSelector:'.ph-no-capture,[data-ph-no-capture],iframe',recordCrossOriginIframes:false,
          recordCanvas:false,recordHeaders:false,recordBody:false,collectFonts:false,maskCapturedNetworkRequestFn:function(request){if(request&&typeof request.name==='string'){try{var u=new URL(request.name,w.location.origin);request.name=u.origin+u.pathname;}catch(_){request.name=request.name.split('?')[0].split('#')[0];}}return request;}},
        before_send:function(e){return sanitize(e,qa);},
        loaded:function(instance){sdk=instance;activate();}};
      if(!sdkStub(opts,cfg.captureToken,function(){phase='sdk_load_failed';ready=false;})){phase='existing_posthog_conflict';}
    }
    w.document.addEventListener('visitorConsentCollected',sync);
    function boot(){
      if(w.Shopify&&w.Shopify.customerPrivacy){sync();return;}
      if(w.Shopify&&typeof w.Shopify.loadFeatures==='function'){
        w.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],function(err){if(err){phase='privacy_api_unavailable';return;}sync();});
      }else phase='privacy_api_unavailable';
    }
    if(w.document.readyState==='loading')w.document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
    return {start:boot,status:function(){return {phase:phase,ready:ready,consent:allowed(),previewQA:qa};}};
  }
  w.ElementiPostHogBootstrap={install:install};
})(window);

